var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.3125,
    height: 10.9375,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 15.3125 10.9375",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#47CE72",
    d: "M15.3125 1.0938q0 .4442-.3076.7861l-8.75 8.75q-.3419.3076-.7862.3076-.4442 0-.7861-.3076l-4.375-4.375Q.0001 5.913 0 5.4687q0-.4785.3418-.7861.3075-.3075.752-.3076.4443 0 .786.3076l3.589 3.623 7.9638-7.998q.3418-.3075.7862-.3076.4443 0 .7519.3076.3417.3077.3418.7862"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check.a360ebabfb38802536c4e6f078bce8cc.svg";